import getBackgroundColor, { BackgroundColors } from "./getBackgroundColor";
import getTextColor, { TextColors } from "./getTextColor";
import getTextAlign, { TextAlignments } from "./getTextAlign";
import hasBottomAngle from "./hasBottomAngle";
import hasExtraTopPadding from "./hasExtraTopPadding";
import getBodyTextStyle, { BodyTextStyles } from "./getBodyTextStyle";

interface Parameters {
  backgroundColor: BackgroundColors;
  textColor: TextColors;
  bottomAngle: string;
  extraTopPad?: string;
  textAlign?: TextAlignments;
  bodyTextStyles?: BodyTextStyles;
}

export default function parseSectionOptions({
  backgroundColor,
  textColor,
  bottomAngle,
  extraTopPad,
  textAlign,
  bodyTextStyles
}: Parameters) {
  return {
    bg: getBackgroundColor(backgroundColor),
    text: getTextColor(textColor),
    angle: hasBottomAngle(bottomAngle),
    topPad: hasExtraTopPadding(extraTopPad!),
    align: getTextAlign(textAlign!),
    bodyStyles: getBodyTextStyle(bodyTextStyles!)
  };
}
